import React, { Component } from "react";
import Estados from "../../data/estados.json";
import Municipios from "../../data/municipios.json";
import { Link, useParams } from "react-router-dom";
import EmpresaContext from "../../context";
import {
  Imóvel,
  Empresa,
  ImoveisInfo as ImoveisInfoType
} from "smart-imob-types";
import { dormitorios, banheiros, vagas, suites } from "../../utils/util_data";
import Spinner from "react-spinner-material";
import get, { post } from "../../client_api";
import ImovelHorizontal from "./horizontal-imovel";
import SelectMultiple from "../global-components/select-multiple";
import { SwapHoriz } from "@styled-icons/material-outlined/SwapHoriz";
import styled, { css } from "styled-components";
import { Windows } from "@styled-icons/fa-brands";
// @ts-ignore
import { compare, getImoveisInfo } from "../../utils/util_functions";
import { ThirtyFpsSelect } from "@styled-icons/material-outlined";
import { string } from "prop-types";

const ButtonContainer = styled.div`
  position: fixed;
  width: 100vw;
  padding: 10px 0;
  left: 0;
  bottom: 0;
  z-index: 10000;
  .btn-container {
    position: relative;
    display: flex;
    justify-content: space-evenly;
  }
  .btn-filter {
    display: block;
    position: relative;
    z-index: 10000;
  }
  .btn-search-mobile {
    display: none;
  }
  ${props =>
    props.menu &&
    css`
      background: #fff;
      border-top: 1px solid #c5c5c5b3;
      .btn-search-mobile {
        display: block;
      }
    `} @media screen and (min-width:990px) {
    display: none;
  }
`;

type FromBannerV2State = {
  bairro: any;
  cidade_id: any;
  estado_uf: any;
  empreendimento_id?: string | null;
  loading_ufs: boolean;
  transacao: "ambas" | "venda" | "locacao";
  tipo: any;
  preço_min_venda: number;
  preço_max_venda: number;
  preço_min_locacao: number;
  preço_max_locacao: number;
  dormitorios: any;
  vagas: any;
  search_title: string;
};

type BuscaConfig = {
  bairro: any;
  banheiros: any | null;
  cidade_id: any;
  dorms: any | null;
  estado_uf: any | null;
  empreendimento_id?: string | null;
  preco_min_venda: number;
  preco_max_venda: number;
  preco_min_locacao: number;
  preco_max_locacao: number;
  suites: any | null;
  transacao: "ambas" | "venda" | "locacao" | string;
  tipo: any;
  vagas: any | null;
};

type SearchListState = {
  codigo: string;
  config: BuscaConfig;
  imoveis: Imóvel[];
  imoveisInfo: ImoveisInfoType;
  last_imóvel_ref: any;
  loading: boolean;
  limites_preco: {
    min: number;
    max: number;
  };
  loading_ufs: boolean;
  loading_limites: boolean;
  loading_cidade: boolean;
  cidades_disponiveis: Cidade[];
  menu: boolean;
  search_title: string;
  total: number | null;
  sorted_search: number;
};
class SearchList extends Component<
  { initialState: FromBannerV2State; locationKey: string },
  SearchListState
> {
  context!: Empresa;
  state: SearchListState = {
    codigo: "",
    config: {
      transacao: this.props.initialState.transacao || "ambas",
      banheiros: null,
      dorms: this.props.initialState.dormitorios || null,
      suites: null,
      vagas: this.props.initialState.vagas || null,
      empreendimento_id: this.props.initialState.empreendimento_id || null,
      estado_uf: this.props.initialState.estado_uf || null,
      cidade_id: this.props.initialState.cidade_id || null,
      bairro: this.props.initialState.bairro || null,
      preco_min_venda: this.props.initialState.preço_min_venda || 0,
      preco_max_venda: this.props.initialState.preço_max_venda || 0,
      preco_min_locacao: this.props.initialState.preço_min_locacao || 0,
      preco_max_locacao: this.props.initialState.preço_max_locacao || 0,
      tipo: this.props.initialState.tipo || null
    },
    imoveis: [],
    last_imóvel_ref: 0,
    imoveisInfo: {
      bairros_disponiveis: [],
      // @ts-ignore
      bairros_array: [],
      cidades_array: [],
      estados_array: [],
      codigos: [],
      codigos_db_id: [],
      min_preco: 0,
      max_preco: 0,
      max_area: 0,
      min_area: 0,
      tipos: [],
      tipos_array: []
    },
    loading: true,
    limites_preco: {
      min: 0,
      max: 0
    },
    loading_ufs: this.props.initialState.loading_ufs || true,
    loading_cidade: true,
    cidades_disponiveis: [],
    loading_limites: true,
    menu: false,
    search_title: this.props.initialState.search_title,
    total: null,
    sorted_search: 0
  };

  setConfig(
    campoNome:
      | "transacao"
      | "banheiros"
      | "dorms"
      | "empreendimento_id"
      | "estado_uf"
      | "cidade_id"
      | "preco_min_venda"
      | "preco_max_venda"
      | "preco_min_locacao"
      | "preco_max_locacao"
      | "tipo"
      | "vagas"
      | "suites"
      | "bairro",
    value
  ) {
    this.setState(prevState => ({
      ...prevState,
      config: {
        ...prevState.config,
        [campoNome]: value
      }
    }));
  }
  setTransacao(novaTransacao: "venda" | "locacao") {
    this.setState(prevState => ({
      ...prevState,
      config: {
        ...prevState.config,
        transacao:
          novaTransacao === prevState.config.transacao ? "ambas" : novaTransacao
      }
    }));
  }
  async setSearchOrder() {
    this.setState(
      prevState => ({
        sorted_search:
          prevState.sorted_search < 2 ? prevState.sorted_search + 1 : 0
      }),
      async () => {
        await this.buscarImoveis(true);
      }
    );
  }
  render() {
    const { imoveisInfo } = this.state;

    const possible_cities =
      this.state.config.estado_uf && this.state.config.estado_uf.value
        ? //@ts-ignore
          imoveisInfo.cidades_array.filter(
            cidade => cidade.estado.value === this.state.config.estado_uf.value
          )
        : // @ts-ignore
          imoveisInfo.cidades_array;

    const selected_cities =
      this.state.config.cidade_id &&
      this.state.config.cidade_id.map(cidade => cidade.value);

    const cities_bairros = selected_cities
      ? //@ts-ignore
        imoveisInfo.bairros_array
          .filter(
            bairro =>
              selected_cities.includes(bairro.info.cidade.id) ||
              selected_cities.includes(bairro.info.cidade.value)
          )
          .sort((a, b) => compare(a.value, b.value))
      : [];

    console.log(
      "%clast_imovel_ref:",
      "color: #e67e22",
      this.state.last_imóvel_ref
    );
    return (
      <div className="search-page-wrap pd-top-100 pd-bottom-70">
        <div className="search-container">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className={`col-xl-3 col-lg-4 ${
                  this.state.menu ? "sitebar open" : "sitebar"
                }`}
              >
                <h6
                  className="filter-title mb-4"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="media-left" style={{ marginRight: 16 }}>
                    <i
                      className="fa fa-search"
                      style={{ color: "var(--main-color-one)" }}
                    />
                  </div>
                  Filtro
                </h6>
                <div className="widget widget-sidebar-search-wrap">
                  <div className="widget-sidebar-search">
                    {this.context.possui_locacao && (
                      <>
                        <div className="title">Transações</div>
                        <div
                          className="widget-sidebar-item-wrap btn-area"
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-around"
                          }}
                        >
                          <div
                            onClick={() => this.setTransacao("venda")}
                            style={{
                              boxShadow:
                                this.state.config.transacao === "venda"
                                  ? "0 0 1px 3px inset rgba(0, 0, 0, 0.45)"
                                  : undefined
                            }}
                            className={"btn btn-yellow"}
                          >
                            Venda
                          </div>
                          <div
                            onClick={() => this.setTransacao("locacao")}
                            style={{
                              boxShadow:
                                this.state.config.transacao === "locacao"
                                  ? "0 0 1px 3px inset rgba(0, 0, 0, 0.45)"
                                  : undefined
                            }}
                            className={"btn btn-yellow float-right"}
                          >
                            Locação
                          </div>
                          {this.context.possui_temporada && (
                            <Link to={"/temporada"}>
                              <div
                                style={{ marginTop: "6px" }}
                                className={"btn btn-yellow float-right"}
                              >
                                Temporada
                              </div>
                            </Link>
                          )}
                        </div>
                      </>
                    )}

                    <div className="title">Localização</div>
                    {this.state.loading_ufs ? (
                      <div
                        className="widget-sidebar-item-wrap"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Spinner
                          radius={30}
                          color={"var(--main-color-one)"}
                          stroke={3}
                          visible={true}
                        />
                      </div>
                    ) : (this.context.mostrar_estados === undefined ||
                      this.context.mostrar_estados === true) &&
                    //@ts-ignore
                    imoveisInfo.estados_array.length > 0 ? (
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          empresa={this.context}
                          isClearable
                          placeholder="Estados"
                          classNamePrefix="home"
                          value={this.state.config.estado_uf || undefined}
                          onChange={e =>
                            this.setState(prevState => ({
                              ...prevState,
                              config: {
                                ...prevState.config,
                                estado_uf: e,
                                cidade_id: [],
                                bairro: []
                              }
                            }))
                          }
                          noOptionsMessage={() => <div>Sem opções</div>}
                          // @ts-ignore
                          options={imoveisInfo.estados_array}
                        />
                      </div>
                    ) : null}
                    {this.state.loading_cidade ? (
                      <div
                        className="widget-sidebar-item-wrap"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Spinner
                          radius={30}
                          color={"var(--main-color-one)"}
                          stroke={3}
                          visible={true}
                        />
                      </div>
                    ) : (
                      // this.state.config.estado_uf &&
                      //@ts-ignore
                      possible_cities.length > 0 && (
                        <div className="widget-sidebar-item-wrap rld-single-select">
                          <SelectMultiple
                            empresa={this.context}
                            isMulti
                            placeholder="Cidades"
                            classNamePrefix="home"
                            value={this.state.config.cidade_id || undefined}
                            onChange={e => this.setConfig("cidade_id", e)}
                            noOptionsMessage={() => <div>Sem opções</div>}
                            options={possible_cities}
                          />
                        </div>
                      )
                    )}
                    {this.state.config.cidade_id &&
                      this.state.config.cidade_id.length > 0 && (
                        <div className="widget-sidebar-item-wrap rld-single-select">
                          <SelectMultiple
                            empresa={this.context}
                            isMulti
                            placeholder="Bairros"
                            classNamePrefix="home"
                            value={this.state.config.bairro || undefined}
                            onChange={e =>
                              this.setConfig("bairro", e || undefined)
                            }
                            noOptionsMessage={() => <div>Sem opções</div>}
                            options={cities_bairros}
                          />
                        </div>
                      )}
                    {this.state.config.transacao === "locacao" ? (
                      <div className="widget-sidebar-item-wrap rld-price-slider-wrap">
                        <div className="title">Valor de locação</div>
                        <div
                          className="rld-single-input"
                          style={{ marginBottom: 30 }}
                        >
                          <input
                            type="text"
                            placeholder="Preço mínimo"
                            value={this.state.config.preco_min_locacao || ""}
                            onChange={e =>
                              this.setConfig(
                                "preco_min_locacao",
                                parseInt(e.target.value)
                              )
                            }
                          />
                        </div>
                        <div className="rld-single-input">
                          <input
                            className="rld-single-input input"
                            type="text"
                            placeholder="Preço máximo"
                            value={this.state.config.preco_max_locacao || ""}
                            onChange={e =>
                              this.setConfig(
                                "preco_max_locacao",
                                parseInt(e.target.value)
                              )
                            }
                          />
                        </div>
                        {!!(
                          this.state.config.preco_max_locacao &&
                          this.state.config.preco_min_locacao
                        ) && (
                          <>
                            <div className="title" style={{ marginTop: 30 }}>
                              Imóveis entre
                            </div>
                            <div className="price" style={{ opacity: 1 }}>
                              <span>
                                {Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL"
                                }).format(this.state.config.preco_min_locacao)}
                              </span>
                              <span className="float-right">
                                {Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL"
                                }).format(this.state.config.preco_max_locacao)}
                              </span>
                            </div>
                            {this.state.config.preco_min_locacao >
                              this.state.config.preco_max_locacao &&
                              !!this.state.config.preco_max_locacao && (
                                <span style={{ color: "firebrick" }}>
                                  Essa busca não é possivel!
                                </span>
                              )}
                          </>
                        )}
                      </div>
                    ) : this.state.loading_limites ? (
                      <div
                        className="widget-sidebar-item-wrap"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Spinner
                          radius={30}
                          color={"var(--main-color-one)"}
                          stroke={3}
                          visible={true}
                        />
                      </div>
                    ) : this.state.limites_preco.min !== 0 ||
                    this.state.limites_preco.max !== 0 ? (
                      <div className="widget-sidebar-item-wrap rld-price-slider-wrap">
                        <div className="title">Valor de venda</div>
                        <div
                          className="rld-single-input"
                          style={{ marginBottom: 30 }}
                        >
                          <input
                            type="text"
                            placeholder="Preço mínimo"
                            value={this.state.config.preco_min_venda || ""}
                            onChange={e =>
                              this.setConfig(
                                "preco_min_venda",
                                parseInt(e.target.value)
                              )
                            }
                          />
                        </div>
                        <div className="rld-single-input">
                          <input
                            className="rld-single-input input"
                            type="text"
                            placeholder="Preço máximo"
                            value={this.state.config.preco_max_venda || ""}
                            onChange={e =>
                              this.setConfig(
                                "preco_max_venda",
                                parseInt(e.target.value)
                              )
                            }
                          />
                        </div>
                        {!!(
                          this.state.config.preco_max_venda ||
                          this.state.config.preco_min_venda
                        ) && (
                          <>
                            <div className="title" style={{ marginTop: 30 }}>
                              Imóveis entre
                            </div>
                            <div className="price" style={{ opacity: 1 }}>
                              <span>
                                {Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL"
                                }).format(
                                  this.state.config.preco_min_venda ||
                                    this.state.limites_preco.min
                                )}
                              </span>
                              <span className="float-right">
                                {Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL"
                                }).format(
                                  this.state.config.preco_max_venda ||
                                    this.state.limites_preco.max
                                )}
                              </span>
                            </div>
                            {this.state.config.preco_min_venda >
                              this.state.config.preco_max_venda &&
                              !!this.state.config.preco_max_venda && (
                                <span style={{ color: "firebrick" }}>
                                  Essa busca não é possivel!
                                </span>
                              )}
                          </>
                        )}
                      </div>
                    ) : null}
                    <div className="rld-single-select">
                      <div className="title">Extra</div>
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          empresa={this.context}
                          isMulti
                          placeholder="Tipos"
                          classNamePrefix="home"
                          value={this.state.config.tipo || 0}
                          onChange={e => this.setConfig("tipo", e || undefined)}
                          noOptionsMessage={() => <div>Sem opções</div>}
                          // @ts-ignore
                          options={imoveisInfo.tipos_array}
                        />
                      </div>
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          isClearable
                          empresa={this.context}
                          placeholder="Dormitórios"
                          classNamePrefix="home"
                          value={this.state.config.dorms || undefined}
                          onChange={e => this.setConfig("dorms", e || null)}
                          noOptionsMessage={() => <div>Sem opções</div>}
                          options={dormitorios}
                        />
                      </div>
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          isClearable
                          empresa={this.context}
                          placeholder="Banheiros"
                          classNamePrefix="home"
                          value={this.state.config.banheiros || undefined}
                          onChange={e => this.setConfig("banheiros", e || null)}
                          noOptionsMessage={() => <div>Sem opções</div>}
                          options={banheiros}
                        />
                      </div>
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          isClearable
                          empresa={this.context}
                          placeholder="Suítes"
                          classNamePrefix="home"
                          value={this.state.config.suites || undefined}
                          onChange={e => this.setConfig("suites", e || null)}
                          noOptionsMessage={() => <div>Sem opções</div>}
                          options={suites}
                        />
                      </div>
                      <div className="widget-sidebar-item-wrap rld-single-select">
                        <SelectMultiple
                          isClearable
                          empresa={this.context}
                          placeholder="Vagas"
                          classNamePrefix="home"
                          value={this.state.config.vagas || undefined}
                          onChange={e => this.setConfig("vagas", e || null)}
                          noOptionsMessage={() => <div>Sem opções</div>}
                          options={vagas}
                        />
                      </div>
                      <div
                        className="widget-sidebar-item-wrap rld-single-input"
                        style={{ marginBottom: 0 }}
                      >
                        <input
                          className="rld-single-input input"
                          type="text"
                          placeholder="Código"
                          value={this.state.codigo}
                          onChange={e =>
                            this.setState({ codigo: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="btn-search-desktop btn-wrap text-center">
                    {!this.state.codigo ? (
                      <button
                        onClick={() => {
                          this.buscarImoveis(true);
                          if (window.screen.width > 800) {
                            window.scrollTo({ top: 0 });
                          }
                        }}
                        className="btn btn-yellow"
                      >
                        <span className="left">
                          <i className="fa fa-search" />
                        </span>
                        Buscar imóvel
                      </button>
                    ) : (
                      <button
                        onClick={async () => {
                          try {
                            const imovel = await get(
                              this.context.url,
                              `imovel_codigo/${this.state.codigo}`
                            );
                            window.open("/imovel/" + imovel.db_id);
                            this.setState({ codigo: "" });
                          } catch (_) {
                            alert("Nenhum imóvel encontrado com esse código!");
                          }
                        }}
                        className="btn btn-yellow"
                      >
                        <span className="left">
                          <i className="fa fa-search" />
                        </span>
                        #{this.state.codigo}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="row mb-3">
                  <div className="col-md-9 col-sm-8">
                    {this.state.total ? (
                      <h6 className="filter-title mt-3 mb-lg-0">
                        {this.state.total} Imóveis
                      </h6>
                    ) : (
                      ""
                    )}
                    <h6
                      className="filter-title mt-3 mb-lg-0"
                      style={{ marginTop: "5px !important" }}
                    >
                      Ordenando por:{" "}
                      <button
                        className="btn-sm btn-yellow"
                        style={{
                          display: "inline-block",
                          border: 0,
                          cursor: "pointer"
                        }}
                        onClick={() => this.setSearchOrder()}
                      >
                        {this.state.sorted_search === 1
                          ? "Menor valor"
                          : this.state.sorted_search === 2
                            ? "Maior valor"
                            : "Mais recentes"}
                        <SwapHoriz size={"24px"} />
                      </button>
                    </h6>
                  </div>
                </div>
                {this.state.imoveis.map((imovel: Imóvel) => (
                  <ImovelHorizontal key={imovel.db_id} imovel={imovel} />
                ))}
                {this.state.loading ? (
                  <div
                    className="widget-sidebar-item-wrap"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 40
                    }}
                  >
                    <Spinner
                      radius={30}
                      color={"var(--main-color-one)"}
                      stroke={3}
                      visible={true}
                    />
                  </div>
                ) : (
                  this.state.imoveis.length === 0 && (
                    <div className="btn-wrap text-center">
                      <button
                        className="btn btn-yellow"
                        style={{ backgroundColor: "gray" }}
                      >
                        Nenhum imóvel foi encontrado!
                      </button>
                    </div>
                  )
                )}
                {this.state.imoveis.length > 0 && (
                  <div className="btn-wrap text-center">
                    {this.state.last_imóvel_ref !== null ? (
                      <button
                        onClick={() => this.buscarImoveis(false)}
                        className="btn btn-yellow"
                        style={{
                          marginBottom: "50px",
                          opacity: this.state.loading ? 0.5 : 1,
                          pointerEvents: this.state.loading ? "none" : undefined
                        }}
                      >
                        <span className="left">
                          <i className="fa fa-search" />
                        </span>
                        Buscar mais imóveis
                      </button>
                    ) : (
                      <button
                        onClick={() => window.scrollTo({ top: 0 })}
                        className="btn btn-yellow"
                        style={{ backgroundColor: "gray" }}
                      >
                        Nenhum imóvel foi encontrado!
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <ButtonContainer menu={this.state.menu}>
              <div className="btn-container">
                <div className="btn-search-mobile">
                  {!this.state.codigo ? (
                    <button
                      onClick={() => {
                        this.buscarImoveis(true);
                        if (window.screen.width > 800) {
                          window.scrollTo({ top: 0 });
                        }
                      }}
                      className="btn btn-yellow"
                    >
                      <span className="left">
                        <i className="fa fa-search" />
                      </span>
                      Buscar imóvel
                    </button>
                  ) : (
                    <button
                      onClick={async () => {
                        try {
                          const imovel = await get(
                            this.context.url,
                            `imovel_codigo/${this.state.codigo}`
                          );
                          window.open("/imovel/" + imovel.db_id);
                          this.setState({ codigo: "" });
                        } catch (_) {
                          alert("Nenhum imóvel encontrado com esse código!");
                        }
                      }}
                      className="btn btn-yellow"
                    >
                      <span className="left">
                        <i className="fa fa-search" />
                      </span>
                      #{this.state.codigo}
                    </button>
                  )}
                </div>
                <div className="btn-filter">
                  <button
                    onClick={() =>
                      this.setState(prevState => ({ menu: !prevState.menu }))
                    }
                    className="btn btn-yellow"
                  >
                    {this.state.menu ? "Fechar" : "Filtrar"}
                  </button>
                </div>
              </div>
            </ButtonContainer>
          </div>
        </div>
      </div>
    );
  }
  formatValue(string) {
    return string
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }
  getSingleValue(campo: string, campoState: any) {
    const query = window.location.pathname.replace("/lista/", "").split("/");
    const campoValue = query[query.indexOf(campo) + 1]
      .replace(/-/g, " ")
      .replace(/_/g, "/");
    if (!!campoValue) {
      this.setConfig(campoState, campoValue);
      // console.log("campo encontrado:", campoURL);
      return campoValue;
    }
  }
  getSimiliarValues(nome_do_array: string, campo: string, campoState: any) {
    const query = window.location.pathname.replace("/lista/", "").split("/");
    if (query.includes(campo)) {
      const campoQuery = query[query.indexOf(campo) + 1]
        .replace(/-/g, " ")
        .replace(/_/g, "/");
      let campoURL: any = [];
      if (campoQuery.includes(",")) {
        const valores = campoQuery.split(",");
        let i = 0;
        while (i !== valores.length) {
          this.state.imoveisInfo[nome_do_array].forEach(valor_do_array => {
            if (
              this.formatValue(valor_do_array.label) ===
              this.formatValue(valores[i])
            ) {
              campoURL = [...campoURL, valor_do_array];
            }
          });
          i++;
        }
      } else {
        campoURL = this.state.imoveisInfo[nome_do_array].find(
          valor_do_array =>
            this.formatValue(valor_do_array.label) ===
            this.formatValue(campoQuery)
        );
        campoURL = campoURL ? [campoURL] : undefined;
      }
      this.setConfig(campoState, campoURL);
      // console.log("campo encontrado:", campoURL);
      return campoURL;
    }
  }

  async componentDidMount() {
    try {
      let imoveisInfo = await getImoveisInfo(this.context.url);
      this.setState({ imoveisInfo });
    } catch (error) {
      console.log("erro ao pegar as informações do imóvel", error);
    }
    this.setState({
      sorted_search:
        this.context.info_gen && this.context.info_gen.search_order
          ? this.context.info_gen.search_order
          : 0
    });

    const { imoveisInfo } = this.state;

    this.getSingleValue("transacao", "transacao");
    this.getSimiliarValues("bairros_array", "bairro", "bairro");
    this.getSimiliarValues("cidades_array", "cidade", "cidade_id");
    this.getSimiliarValues("tipos_array", "tipo", "tipo");

    const getBuscaTitle = async () => {
      try {
        let busca = await get(
          this.context.url,
          `/imoveis_busca_titulo_lista?input=${this.state.search_title}`
        );
        return busca;
      } catch (error) {
        console.log("erro ao pegar os imóveis pela busca por titulo", error);
      }
    };

    if (this.state.search_title) {
      const ImoveisBuscaTitulo = await getBuscaTitle();
      this.setState({
        last_imóvel_ref: null,
        loading: false,
        imoveis: ImoveisBuscaTitulo
      });
      console.log(`busca`, ImoveisBuscaTitulo);
    } else {
      let imoveisIniciaisQtd = await this.buscarImoveis(true);
    }

    const empresa = this.context;

    this.setState({
      loading_ufs: false,
      loading_cidade: false
    });
    /**
     * @desc pega o imóvel mais caro e o mais barato da empresa e separa os valores para serem usados na busca de preço mínimo e máximo
     */
    try {
      const precos = await get(this.context.url, "preco");
      this.setState({
        limites_preco: {
          min: Number(precos.min),
          max: Number(precos.max)
        },
        loading_limites: false
      });
    } catch (_) {
      this.setState({
        limites_preco: {
          min: 0,
          max: 0
        },
        loading_limites: false
      });
    }
  }
  async buscarImoveis(reset: boolean) {
    const searchProperty = async () => {
      let { config } = this.state;
      const filtros = {};
      console.log("%cConfig", "color: #3498db", config);

      this.setConfig("empreendimento_id", null);

      filtros["transacao"] = config.transacao;
      filtros["bairro"] =
        config.bairro && config.bairro.length > 0
          ? config.bairro.map(bairro => bairro.value)
          : undefined;
      filtros["cidade_id"] =
        config.cidade_id && config.cidade_id.length > 0
          ? config.cidade_id.map(cidade => cidade.value)
          : undefined;
      filtros["estado_id"] =
        config.estado_uf && config.estado_uf.value
          ? config.estado_uf.value
          : undefined;
      filtros["tipos"] =
        config.tipo && config.tipo.length > 0
          ? config.tipo.map(tipo => tipo.value)
          : undefined;
      filtros["vagas"] = config.vagas ? config.vagas.value : "";
      filtros["dorms"] = config.dorms ? config.dorms.value : "";
      filtros["banheiros"] = config.banheiros ? config.banheiros.value : "";
      filtros["suítes"] = config.suites ? config.suites.value : "";
      filtros["preco_min_venda"] = config.preco_min_venda;
      filtros["preco_max_venda"] = config.preco_max_venda;
      filtros["preco_min_locacao"] = config.preco_min_locacao;
      filtros["preco_max_locacao"] = config.preco_max_locacao;

      console.log("%cFiltros", "color: #f1c40f", filtros);

      try {
        let imoveis_fetch = await post(this.context.url, "buscar_imoveis", {
          filtros: filtros,
          limit: 12,
          startAt: this.state.last_imóvel_ref,
          order: this.state.sorted_search
        });
        console.log("%cImoveis_fetch", "color: #2ecc71", imoveis_fetch);
        const { imoveis, total } = imoveis_fetch;
        this.setState(prevState => ({
          imoveis: [...prevState.imoveis, ...imoveis],
          last_imóvel_ref:
            imoveis && imoveis.length > 0
              ? prevState.last_imóvel_ref !== null &&
                prevState.last_imóvel_ref + 12
              : null,
          total: total,
          loading: false
        }));
        if (imoveis.length < 12) {
          this.setState({
            last_imóvel_ref: null
          });
        }
        return imoveis.length;
      } catch (_) {
        console.log(_);
        this.setState({ loading: false, imoveis: [], last_imóvel_ref: null });
        return 0;
      }
    };

    if (reset) {
      this.setState(
        {
          last_imóvel_ref: 0,
          imoveis: [],
          loading: true,
          menu: false
        },
        async () => await searchProperty()
      );
    } else {
      this.setState(
        {
          loading: true,
          menu: false
        },
        async () => await searchProperty()
      );
    }
  }

  componentDidUpdate(prevProps, prevState: SearchListState) {
    try {
      if (
        this.props.initialState.tipo !== this.state.config.tipo &&
        prevProps.locationKey !== this.props.locationKey
      ) {
        this.setState(
          prevState => ({
            ...prevState,
            config: {
              ...prevState.config,
              tipo: this.props.initialState.tipo
            }
          }),
          async () => {
            let imoveisIniciaisQtd = await this.buscarImoveis(true);
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
    try {
      // console.log(
      //   "ativando",
      //   this.props.initialState.cidade_id,
      //   this.state.config.cidade_id
      // );
      if (
        this.props.initialState.cidade_id !== this.state.config.cidade_id &&
        prevProps.locationKey !== this.props.locationKey
      ) {
        // console.log("ativando dentro do if");
        this.setState(
          prevState => ({
            ...prevState,
            config: {
              ...prevState.config,
              cidade_id: this.props.initialState.cidade_id
            }
          }),
          async () => {
            let imoveisIniciaisQtd = await this.buscarImoveis(true);
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
}
SearchList.contextType = EmpresaContext;
export default SearchList;

type Cidade = {
  id: number;
  nome: string;
};
type CidadeApi = {
  i: number;
  n: string;
  uf: number;
};
